import React from "react";
import { DropdownBox, InputField, Label, Row, SwitchToggle } from "client/CommonComponents";
import { useSelector } from "react-redux";

interface IProps {
  applicationListData?: any;
  appAreaForm?: any
  handleChange?: any;
  formError?: any;
  setAppAreaForm?: any;
}

const AppAreaModal = ({
  appAreaForm,
  handleChange,
  formError
}: IProps) => {
  const {
    applicationDropDown
  }: any
    = useSelector(
      (state: any) => ({
        applicationDropDown: state.UserManagement.activeApplicationData
      })
    )

  return (
    <>
      <Row>
        <Label required data-attribute="AppAreaModal_Default_Label">Application</Label>
        <DropdownBox
          options={applicationDropDown}
          placeholder="--Select--"
          className="mb-3"
          name="application"
          value={appAreaForm.application}
          onChange={handleChange}
          selectedKey={appAreaForm.application.key}  data-attribute="AppAreaModal_application_Dropdown" />
        {formError?.applicationError ? (
          <span className="appArea-validation-msg">
            {formError?.applicationError}
          </span>
        ) : null}
        <Label required title="name" data-attribute="AppAreaModal_name_Label">
          Name
        </Label>
        <InputField
          name="areaName"
          className="mb-3"
          onChange={handleChange}
          value={appAreaForm.areaName}
         data-attribute="AppAreaModal_areaName_Input" />
        {formError?.areaNameError ? (
          <span className="appArea-validation-msg">
            {formError?.areaNameError}
          </span>
        ) : null}
        <Label required title="areaId" data-attribute="AppAreaModal_areaId_Label">
          App Area Code
        </Label>
        <InputField
          name="areaId"
          className="mb-3"
          onChange={handleChange}
          value={appAreaForm.areaId}
         data-attribute="AppAreaModal_areaId_Input" />
        {formError?.areaIdError ? (
          <span className="appArea-validation-msg">
            {formError?.areaIdError}
          </span>
        ) : null}
        <Label title="active" data-attribute="AppAreaModal_active_Label">
          Active
        </Label>
        <SwitchToggle
          name="isActive"
          onChange={handleChange}
          checked={appAreaForm.isActive}
         data-attribute="AppAreaModal_isActive_SwitchToggle" />
      </Row>
    </>
  );
};

export default AppAreaModal;
